import React from 'react';

export const Loading = () => <i className="custom-spin uil uil-sync"></i>;

